import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './pc.css';
import PcApp from './PcApp';
import { AlertProvider } from '../components/Alert';

/**
 * PC 端入口。
 *
 * ★ 只引 `./pc.css` —— **不引 `../styles/*.css` 里的任何一个**。
 *   手机端那套的第一条规则就是 `body{display:flex;...}` ＋ `.phone{width:418px;height:872px}`，
 *   漏进来 PC 页就会被压成一个居中的手机壳。样式隔离是这一路的硬约束，不是偏好。
 * ★ 没有 react-router：这一页就是一件事（提交投诉），成功后原地换成结果面板。
 *   多挂一个路由器只会让「独立打开的一张页面」多出可以走丢的地方。
 * ★ `AlertProvider` / `AlertLayer` 直接复用手机端那一份组件（`components/Alert.tsx`），
 *   不抄第二份：所有失败提示走弹窗这条纪律，两个入口共用同一个实现。
 */

const el = document.getElementById('pc-root');
if (!el) throw new Error('#pc-root 不存在');

createRoot(el).render(
  <StrictMode>
    <AlertProvider>
      <PcApp />
    </AlertProvider>
  </StrictMode>,
);
